// @import "~@govbr-ds/core/src/components/header-function/header-function";

:host {
  display: block;
}

@media (width >= 1280px) {
  .br-header-function {
    &::part(default-content) {
      padding-left: var(--spacing-scale-half);
      padding-right: var(--spacing-scale-half);
    }
  }
}
